<template>
  <div class="article-edit-container">
    <div>
      <bread-crumb />
    </div>
    <div class="global-table-container">
      <basic-form
        ref="basicForm"
        :form-data="formData"
      >
       <template #is_top>
          <a-radio-group
            v-decorator="[
              'is_top',
              { rules: [{ required: true, message: '请选择置顶状态' }],initialValue:data.is_top }
            ]"
          >
            <a-radio :value="1">
              是
            </a-radio>
            <a-radio :value="0">
              否
            </a-radio>
          </a-radio-group>
        </template>
		<template #status>
		   <a-radio-group
		     v-decorator="[
		       'status',
		       { rules: [{ required: true, message: '请选择显示状态' }],initialValue:data.status }
		     ]"
		   >
		     <a-radio :value="1">
		       显示
		     </a-radio>
		     <a-radio :value="0">
		       隐藏
		     </a-radio>
		   </a-radio-group>
		 </template>
        <template #type>
			<a-select
			  v-decorator="['type',{rules: [
			    { required: true, message: '请选择类型' },
			  ],initialValue:data.type}]"
			  placeholder="请选择类型"
			>
			  <a-select-option :value="1">新闻资讯</a-select-option>
			   <a-select-option :value="2">常见问题</a-select-option>
			</a-select>
        </template>
        <template #name>
          <a-input
            v-decorator="['name',{rules: [
              { required: true, message: '请输入标题' },
            ],initialValue:data.name}]"
            placeholder="请输入标题"
          />
        </template>

        <template #post_content>
          <div
            ref="editor"
            class="content"
          />
          <div
            v-show="isContent"
            class="content-error"
          >
            请输入内容
          </div>
        </template>
        <template #thumbnail>
          <a-upload
            v-decorator="[
              'thumbnail',
              {
                initialValue: data.thumbnail,
                rules: [{ required: true, message: '请上传图片' }] ,
                valuePropName: 'fileList',
                getValueFromEvent: normFile,
              },
            ]"
            name="upload"
            accept=".jpg, .png, .jpeg"
            list-type="picture-card"
            class="avatar-uploader"
            :show-upload-list="false"
            :data="{fileType:'img',}"
            :action="`${uploadUrl}fileup/up`"
            :before-upload="beforeUpload"
			@change="handleChange"
          >
            <div  v-if="data.thumbnail.length>0&&imageUrl===''">
				<img
				 v-for="(img,index) in data.thumbnail"
				  width="175"
				  height="80"
				  :src="img.url"
				  alt="avatar"
				>
			</div>
            <div v-if="data.thumbnail.length==0&&imageUrl===''">
              <a-icon :type="loading ? 'loading' : 'plus'" />
              <div class="ant-upload-text">
                上传
              </div>
            </div>
			<div  v-if="imageUrl!=''">
				<img
				  width="175"
				  height="80"
				  :src="imageUrl"
				  alt="avatar"
				>
			</div>
          </a-upload>
        </template>
        <template #list_order>
          <a-input-number
            v-decorator="['list_order',{rules: [
              { required: true, message: '请输入排序' },
            ],initialValue:data.list_order}]"
            placeholder="请输入排序"
          />
        </template>
      </basic-form>
      <form-button
        :btn-is-loading="btnIsLoading"
        @onCancel="onCancel"
        @onSubmit="handleSubmit"
      />
	 
    </div>
  </div>
</template>
<script>
	function getBase64(img, callback) {
	  const reader = new FileReader();
	  reader.addEventListener('load', () => callback(reader.result));
	  reader.readAsDataURL(img);
	}
import {formDataCompany, formDataService } from './../data/index';
import E from 'wangeditor';
export default {
  data() {
    return {
      formData: formDataService,
      companyData: [],
      parentData: [],
	  productData:[],
	  imageUrl:'',
      loading: false,
      btnIsLoading: false,
      editorContent: '',
      isContent: false,
      data: {thumbnail: [],is_top:0,status:1},
    };
  },
  created(){
    if (this.$store.state.user.role === 1) {
      this.formData=formDataService;
      this.getCompanyList();
    } else {
      this.formData = formDataService;
    }
  },
  async mounted() {
	  // 获取产品
	  this.getProduct();
    // 获取栏目
    this.getParentData();
    // 编辑内容
    let editor = new E(this.$refs.editor);
    editor.customConfig={
      onchange: (html) => {
        this.editorContent = html;
      },
      customUploadImg: async(files, insert)=> {
        console.log('mounted -> files', files);
        let formData=new FormData();
        files.forEach((item)=>{
          formData.append('upload[]', item);
        });

        let result =await this.$http.post('/fileup/uploadMore', formData);
        if(result.data.status===1){
          result.data.data.data_list.forEach((item)=>{
            insert(item);
          });

        }
      },
    };
    editor.create();
    // 回显
    if(this.$route.query.id){
      await this.getData({id: this.$route.query.id});
      await editor.txt.html(this.editorContent);
    }
  },
  methods: {
	  handleChange(info) {
	        if (info.file.status === 'uploading') {
	          this.loading = true;
	          return;
	        }
	        if (info.file.status === 'done') {
	          getBase64(info.file.originFileObj, imageUrl => {
	            this.imageUrl = imageUrl;
	            this.loading = false;
	          });
	        }
	      },
	  // 获取合作企业
	  async getProduct() {
	    let result = await this.$http.post('/product/getList');
	    if (result.data.status === 1) {
	      this.productData = result.data.data.data_list;
	    }
	  },
    // 回显
    async getData(params){
      let result=await this.$http.post('/portalPost/info', params);
      if(result.data.status===1){
        let temp=result.data.data;
        this.data=temp;
        this.$set(this.data, 'thumbnail', [{
          uid: temp.thumbnail,
          url: temp.thumbnail_url,
          status: 'done',
          name: 'img',
        }]);
		
        this.editorContent=temp.post_content;
		
      }
    },
    normFile(e) {
      if (e && e.file.status === 'uploading') {
        this.loading = true;
      }
      if (e && e.file.status === 'done') {
        const fileList = [
          {
            uid: e.file.response.data.id,
            status: 'done',
            name: 'img',
            url: e.file.response.data.url,
          },
        ];
        this.loading = false;
        return fileList;
      }
      return e.fileList;
    },
    // 上传前
    beforeUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 10;
      if (!isLt2M) {
        this.$message.error('图片小于10M！');
      }
      return isLt2M;
    },
    // 获取合作企业
    async getCompanyList() {
      let result = await this.$http.post('/Company/getCooperationCompanyList');
      if (result.data.status === 1) {
        this.companyData = result.data.data.data_list;
      }
    },
    // 递归处理
    dealData(data) {
      data.forEach((item) => {
        item.title = item.name;
        item.key = item.id;
        item.value = String(item.id);
        item.children = item.child_list;
        item.selectable=false;
        if (item.child_list && item.child_list.length > 0) {
          item.child_list.forEach((list)=>{
            list.title = list.name;
            list.key = list.id;
            list.value = String(list.id);
          });
        }
      });
      return data;
    },
    // 获取栏目数据
    async getParentData() {
      let result = await this.$http.post('/portalPost/groupList');
      if (result.data.status === 1) {
        let data = result.data.data.data_list;
        this.parentData = this.dealData(JSON.parse(JSON.stringify(data)));
      }
    },
    // 提交
    handleSubmit() {
      this.$refs.basicForm.form.validateFields(async(err, values) => {
        console.log('TCL: handleSubmit -> values', values);
        console.log(this.editorContent);
        if(!this.editorContent){
          this.isContent=true;
        }
        if (!err&&this.editorContent) {
          this.isContent=false;
          if (this.$route.query) {
            this.id = this.$route.query.id;
          }
          let data = {
            id: this.id ? this.id : undefined,
            polymorphic_type: values.polymorphic_type,
            company_id: values.company_id,
            group_id: values.group_id,
            name: values.name,
			product_id:values.product_id,
            post_excerpt: values.post_excerpt,
            hits: String(values.hits),
            likes: String(values.likes),
            favorites: String(values.favorites),
            list_order: String(values.list_order),
            thumbnail: values.thumbnail[0].uid,
			is_top:values.is_top,
            post_content: this.editorContent,
			status: values.status,
			type:values.type,
          };
          this.btnIsLoading = true;
          let result = await this.$http.post(
            '/portalPost/update',
            data,
          );
          this.btnIsLoading=false;
          if (result.data.status === 1) {
            this.$message.success('操作成功！');
            this.$router.back();
          }
        }
      });
    },
    // 返回
    onCancel() {
      this.$router.back();
    },
  },
};
</script>
<style scoped lang="scss">
.article-edit-container {
  /deep/ .ant-form-item-no-colon {
    .ant-form-item-label {
      text-align: right;
      .ant-form-item-required {
        &::before {
          display: inline-block;
          content: "*";
          color: #f5222d;
          font-size: 14px;
          line-height: 1;
        }
        &::after {
          content: "";
        }
      }
    }
  }
  .content {
    &::before {
      display: inline-block;
      content: "*";
      color: #f5222d;
      font-size: 14px;
      line-height: 1;
      position: absolute;
      left: -60px;
      top: 15px;
    }
  }
    .content-error{
      color: #f5222d;
    }

  .ant-input-number {
    width: 100%;
  }
}

</style>